import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { MainPage } from "./pages/main";

function App() {
    return (
        <div className="App">
            <MainPage />
        </div>
    );
}

export default App;
